import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useProcessCallInsights = () => {
  const queryClient = useQueryClient();

  const processCallInsights = useMutation({
    mutationFn: async (callId: string) => {
      const { data, error } = await supabase.functions.invoke('process-call-insights', {
        body: { call_id: callId }
      });

      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['call-insights'] });
      queryClient.invalidateQueries({ queryKey: ['contact-insights'] });
      toast.success(data.message || 'Insights gerados com sucesso!');
    },
    onError: (error: any) => {
      console.error('Erro ao processar insights:', error);
      
      if (error.message?.includes('429')) {
        toast.error('Rate limit excedido. Aguarde alguns minutos e tente novamente.');
      } else if (error.message?.includes('402')) {
        toast.error('Créditos insuficientes. Adicione créditos em Settings → Workspace → Usage.');
      } else if (error.message?.includes('muito curta')) {
        toast.error('Call muito curta para análise (mínimo 60s)');
      } else if (error.message?.includes('Gravação não encontrada')) {
        toast.error('Esta call não possui gravação disponível');
      } else {
        toast.error(error.message || 'Erro ao gerar insights');
      }
    },
  });

  return {
    processCallInsights: processCallInsights.mutateAsync,
    isProcessing: processCallInsights.isPending,
  };
};
